import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

const featuredSlugs = [
  'hong-kong-category-iii-origin',
  'golden-era-category-iii',
  'fruit-of-eden-analysis',
  'sociology-of-category-iii',
  'category-iii-global-comparison',
  'aesthetics-of-category-iii',
];

export default function FeaturedArticles() {
  const featuredArticles = featuredSlugs
    .map((slug) => articles.find((a) => a.slug === slug))
    .filter(Boolean) as typeof articles;

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950 mb-3">
              精选文章
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              深度解读三级片的分级制度、历史演变与文化意义
            </p>
          </div>
          <Link
            to="/category/grading-system"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}